import { userApi } from '@/lib/axios';

export const requestLoginSmsCode = (data) => {
  return userApi.post('/user/shopitrade/send-sms-code-for-admin-login', data);
};

export const loginWithSmsCode = (data) => {
  return userApi.post('/user/shopitrade/verify-sms-code-for-login', data);
};
